import React from "react";
import HeaderNav from "../../header/header";
import {Button, Col, DatePicker, Form, Input, Layout, Modal, Row, Select, Space, Table} from "antd";
import EditableTable from "./editTable";
import "../css/SingleCreateFinancialClaim.css"

const { Content } = Layout;

class SingleFinancialClaimEdit extends React.Component{
    constructor(props) {
        super(props);
        this.state={

        }
    }
    render() {
        return <div title="Edit Financial Claim"

            >
            <Layout className="site-layout-background singleFinancialClaimEdit">
                <Content style={{ padding: '0 24px', minHeight: 280 }}>

                    <EditableTable />

                </Content>
            </Layout>
        </div>
    }
}

export default SingleFinancialClaimEdit;